/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import { Record } from 'immutable';
import { actionTypes } from '../actions/dialog';
import { actionTypes as userActionTypes } from '../actions/user';

export const Dialog = new Record(
  {
    id: null,
    show: false,
    accountId: 0,
  },
  'Dialog'
);

export default function reducer(state = new Dialog(), action) {
  switch (action.type) {
    case actionTypes.DIALOG_OPEN: {
      return state.merge({ show: action.show, id: action.id, accountId: action.accountId });
    }
    case actionTypes.DIALOG_CLOSE: {
      return new Dialog();
    }
    case userActionTypes.USER_INVITE_FORM_SUBMIT: {
      return state.merge({ show: true, id: 'successDialog', accountId: action.accountId });
    }
    default: {
      return state;
    }
  }
}
